import { Card, CircularProgress, Tooltip, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import cssClasses from "../EMandate/EMandateAllotments.module.css";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { errorTost } from "../../Services/Toast";
import { getLeadAllotments } from "../../Services/Allotment";
import EmptyListIcon from "../../Assets/Images/EmptyDataIcons/Artwork.svg";
import * as _ from "lodash";
import AllotmentCalenderIcon from "../../Assets/Images/Common/AllotmentCalender.svg";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const EMandateAllotmentHandlerPage = ({
  filterAllotmentsData,
  mandateRegistrationData,
}) => {
  // console.log("filterAllotmentsData --->", filterAllotmentsData);
  // const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [allAllotments, setAllAllotments] = useState([]);
  const [redirecting, setRedirecting] = useState(false); // New state to control redirection
  const [totalAllotments, setTotalAllotments] = useState(0);
  const [allotmentsPresent, setAllotmentsPresent] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  TimeAgo.setDefaultLocale(en.locale);
  TimeAgo.addLocale(en);

  const [allotmentDetails, setAllotmentDetails] = useState({});
  const [mandateAmounts, setMandateAmounts] = useState({}); // Store totalMandateAmount by bookingId

  // ===============================
  // ✅ AUTO REDIRECT LOGIC (ADDED)
  // ===============================
  // memoize the unique allotmentPaymentId
  const uniqueAllotments = useMemo(() => {
    return [...new Set(allAllotments.map((item) => item.allotmentPaymentId))];
  }, [allAllotments]);

  // rest of your code remains the same...

  useEffect(() => {
    if (!allAllotments || allAllotments.length === 0 || redirecting) return;

    // Only proceed if exactly ONE allotment exists
    if (uniqueAllotments.length === 1) {
      const onlyAllotment = allAllotments[0];
      const emandates = onlyAllotment.emandatesData || [];

      // Start loading when redirect decision starts
      setIsLoading(true);
      presentLoader();

      // Check if any mandate is registered
      const isAnyRegistered = emandates.some(
        (mandate) => mandate.isRegistered === true,
      );

      if (isAnyRegistered) {
        // Set the redirect flag to true to avoid any flicker
        setRedirecting(true);
        // Wait for the redirect state to update
        setTimeout(() => {
          navigate("/Home/EMandateDashboard", {
            state: {
              mandateRegistrationData: emandates,
              allotmentPaymentId: onlyAllotment.allotmentPaymentId,
              allotment: onlyAllotment,
            },
          });
        }, 100); // Short delay to ensure state change
      } else {
        dismissLoader();
        setIsLoading(false);
      }
    }
  }, [uniqueAllotments, navigate, redirecting, mandateAmounts, allAllotments]);

  // console.log("Redirect Check:", {
  //   totalAllotments: allAllotments.length,
  //   uniqueIds: [...new Set(allAllotments.map((a) => a.allotmentPaymentId))],
  //   emandates: allAllotments[0]?.emandatesData,
  // });

  useEffect(() => {
    dispatch(actions.activeMenu("emandateallotments"));
    getAllotments();
  }, [loggedInUser, filterAllotmentsData]);

  async function getAllotments() {
    presentLoader();
    setIsLoading(true);
    // console.log("loggedInUser.leadId ====> ", loggedInUser.leadId);
    const startTime = Date.now(); // ⏱ record start time
    const MINIMUM_LOADER_TIME = 1500; // 1.5 seconds (change if needed)

    try {
      const resp = await getLeadAllotments(loggedInUser.leadId);
      // .then((resp) => {
      // console.log("resp ==============> ", resp);
      if (resp.data && Array.isArray(resp.data)) {
        const fetchedEmandates = resp.data;
        if (fetchedEmandates.length > 0) {
          const combinedData = fetchedEmandates.map((paymentIdData) => {
            // Find matching records in filterAllotmentsData based on allotmentPaymentId
            const matchedEmandates = filterAllotmentsData.filter(
              (mandate) =>
                mandate.allotmentPaymentId === paymentIdData.allotmentPaymentId,
            );

            // Log the matched data for debugging
            // console.log(
            //   `Matched Mandates for allotmentPaymentId ${paymentIdData.allotmentPaymentId}:`,
            //   matchedEmandates,
            // );

            // If there are matched emandates, merge them with the corresponding fetchedEmandates data
            return {
              ...paymentIdData, // Spread the properties of paymentIdData from fetchedEmandates
              emandatesData:
                matchedEmandates.length > 0 ? matchedEmandates : [], // Merge matched data or use empty array if no matches
            };
          });

          // console.log("Combined Data:", combinedData);
          setAllAllotments(combinedData);
          setTotalAllotments(combinedData.length);
          setAllotmentsPresent(combinedData.length > 0);

          if (combinedData.length > 0) {
            setAllotmentsPresent(true);
            if (allotmentDetails && allotmentDetails.allotmentPaymentId) {
              const selectedAllotment = _.find(
                combinedData,
                (_allotment_) =>
                  _allotment_.allotmentPaymentId ===
                  allotmentDetails.allotmentPaymentId,
              );
              setAllotmentDetails(selectedAllotment ? selectedAllotment : null);
            }
          } else {
            setAllotmentsPresent(false);
          }
        } else {
          setAllotmentsPresent(false);
        }
      }
      setIsLoading(false); // Stop loading when the data fetch completes
      dismissLoader();
      // })
      // .catch((err) => {
      //   console.log("err: ", err);
      //   errorTost("Could not get allotments!");
      //   dismissLoader();
      // });
    } catch (error) {
      console.log("err: ", error);
      errorTost("Could not get allotments!");
      dismissLoader();
    } finally {
      const elapsedTime = Date.now() - startTime;

      if (elapsedTime < MINIMUM_LOADER_TIME) {
        await delay(MINIMUM_LOADER_TIME - elapsedTime);
      }

      setIsLoading(false);
      dismissLoader();
      // const elapsedTime = Date.now() - startTime;
      // const remainingTime = MINIMUM_LOADER_TIME - elapsedTime;
      // if (remainingTime > 0) {
      //   setTimeout(() => {
      //     dismissLoader();
      //     setIsLoading(false);
      //   }, remainingTime);
      // } else {
      //   dismissLoader();
      //   setIsLoading(false);
      // }
    }
  }

  // Memoize the function that fetches the total mandate amount
  const fetchTotalMandateAmount = useCallback(async (bookingId) => {
    try {
      // 🔄 start loader for all the requested bookingId
      presentLoader();

      const response = await axios.post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}emandate/getPaymentPlanByBookingId`,
        {
          bookingId, // Send the list of bookingId in the request body
        },
      );

      const data = response.data;

      // Handle case where no payment plan is found
      if (response.status === 404 && data.success === false) {
        setMandateAmounts((prevState) => ({
          ...prevState,
          [bookingId]: {
            totalMandateAmount: 0, // Update state with a message
          },
        }));
      } else {
        // If data is available, update state with the totalMandateAmount
        setMandateAmounts((prevState) => ({
          ...prevState,
          [bookingId]: {
            totalMandateAmount: data.totalMandateAmount || 0, // Use 0 as default if totalMandateAmount is not provided
          },
        }));
      }

      dismissLoader();
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching totalMandateAmount", error);

      // Handle errors gracefully for each bookingId
      setMandateAmounts((prevState) => ({
        ...prevState,
        [bookingId]: {
          totalMandateAmount: 0, // Set a generic error message
        },
      }));

      // errorTost(
      //   error.response?.data?.message ||
      //     "Could not fetch the payment plan details.",
      // );
    } finally {
      setIsLoading(false); // Ensure loading state is stopped even if there's an error
      dismissLoader(); // Dismiss loader after data fetching is done
    }
  }, []);

  // Optimized useEffect hook to fetch data only when needed
  useEffect(() => {
    if (allotmentsPresent) {
      allAllotments.forEach((allotment) => {
        const bookingId = allotment?.bookingId; // Extract bookingId from each allotment
        // console.log("Checking mandate amount for bookingId:", bookingId);

        // // Check if bookingId is null and disable the button, throw an error if needed
        // if (!bookingId) {
        //   console.error("Error: bookingId is null for allotment:", allotment);
        //   // Optionally show a toast or message to the user
        //   errorTost(
        //     "Booking ID is missing, cannot proceed with mandate amount retrieval.",
        //   );
        //   return; // Skip fetching mandate amount for this allotment
        // }

        // Fetch mandate amount only if it's not already fetched
        if (bookingId && !mandateAmounts[bookingId]) {
          // console.log("Fetching mandate amount for bookingId:", bookingId);
          fetchTotalMandateAmount(bookingId); // Fetch the data for the specific bookingId
        }
      });
    }
  }, [
    allotmentsPresent,
    allAllotments,
    mandateAmounts,
    fetchTotalMandateAmount,
  ]);

  // const handleOpenEMandate = (allotment) => {
  //   console.log("allotment in handle open e mandate");

  //   navigate("/Home/EMandateSplit", {
  //     state: {
  //       totalAmount: allotment.totalUnitPrice,
  //       allotment, // optional
  //       allotmentPaymentId: allotment.allotmentPaymentId, // ✅ SINGLE ID
  //       totalMandateAmount:
  //         mandateAmounts[allotment?.bookingId]?.totalMandateAmount || 0,
  //       bookingId: allotment?.bookingId,
  //     },
  //   });
  // };

  // Handle the redirection when the user clicks the button
  // Handle Button Click
  const handleButtonClick = (allotment) => {
    // console.log("Allotment emandatesData:", allotment.emandatesData);
    // console.log(
    //   " allotment.emandatesData[0]?.emandates",
    //   allotment.emandatesData,
    // );
    // Set the redirect flag to true to avoid flickering
    setRedirecting(true);
    // Check if emandatesData exists and has data
    const emandates = allotment?.emandatesData || [];
    const isAnyRegistered = emandates.some(
      (mandate) => mandate.isRegistered === true,
    );

    // console.log("isAnyRegistered:", isAnyRegistered);

    if (isAnyRegistered) {
      // Redirect to Dashboard if any isRegistered is true
      navigate("/Home/EMandateDashboard", {
        state: {
          mandateRegistrationData: emandates, // Pass the entire emandates array to the dashboard
          allotmentPaymentId: allotment.allotmentPaymentId,
          allotment, // optional
        },
      });
    } else {
      // Redirect to E-Mandates if none are registered
      navigate("/Home/EMandateSplit", {
        state: {
          totalAmount: allotment.totalUnitPrice,
          allotment, // optional
          allotmentPaymentId: allotment.allotmentPaymentId, // ✅ SINGLE ID
          totalMandateAmount:
            mandateAmounts[allotment?.bookingId]?.totalMandateAmount || 0,
          bookingId: allotment?.bookingId,
        },
      });
    }
  };
  // console.log("allAllotments in handler---->", allAllotments);

  // The component will return nothing while the redirection happens, preventing UI flicker
  useEffect(() => {
    // If redirecting is true, prevent rendering
    if (redirecting) {
      return;
    }

    // If you need to handle other side effects, add them here
  }, [redirecting]);

  if (isLoading) {
    return (
      <div className={cssClasses.loaderWrapper}>
        <div className={cssClasses.loader}>
          {/* Replace with Material UI CircularProgress or your custom loader */}
          <CircularProgress size={22} sx={{ color: "white" }} />
        </div>
      </div>
    );
  }

  // Calculate the eligibleAllotments outside the JSX rendering block
  const eligibleAllotments = allAllotments?.filter(
    (allotment) =>
      allotment?.status === "Agreement Done" &&
      allotment?.CRM?.[0]?.isEmandateEligible === true &&
      (allotment?.CRM?.[0]?.newPaymentPlan?.Id === 163 ||
        allotment?.CRM?.[0]?.newPaymentPlan?.Id === 165),
  );

  return (
    <div className={cssClasses.wrapperTargetPage}>
      <div className={cssClasses.mainContent}>
        <div className={cssClasses.headerMainContent}>
          <div className={cssClasses.wrapperHeader}>
            <div className={cssClasses.wrapperTitleUserName}>
              <div className={cssClasses.headerTitle}>
                Your Eligible Allotments
              </div>
              <div>
                <span style={{ fontSize: "1.25rem" }}>
                  Select an allotment to proceed with E-Mandate registration
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className={cssClasses.eventsWrapper}>
          {/* If there are eligible allotments, show them */}
          {eligibleAllotments?.length > 0 ? (
            eligibleAllotments.map((allotment) => {
              const isDashboard = allotment?.emandatesData?.some(
                (mandate) => mandate.isRegistered === true,
              );

              return (
                <Card
                  key={allotment.bookingId}
                  className={`${cssClasses.card} ${
                    isDashboard ? cssClasses.dashboardCard : ""
                  }`}
                  sx={{ boxShadow: "none !important" }}
                >
                  <div
                    className={
                      isDashboard
                        ? cssClasses.dashboardInner
                        : cssClasses.emandateInner
                    }
                  >
                    {/* HEADER */}
                    <div className={cssClasses.cardHeaderNew}>
                      <div>
                        <h3 className={cssClasses.projectName}>
                          {allotment?.unitId?.projectId?.projectName}
                        </h3>
                        <p className={cssClasses.projectSub}>
                          {allotment?.unitId?.wingId?.displayName ||
                            allotment?.unitId?.wingId?.wingName}
                        </p>
                      </div>

                      <span className={cssClasses.bhkPill}>
                        {allotment?.unitId?.inventoryTypeId?.type}
                      </span>
                    </div>

                    {/* UNIT INFO */}
                    <div className={cssClasses.unitRow}>
                      <div className={cssClasses.unitItem}>
                        <img src={AllotmentCalenderIcon} alt="" />
                        <div>
                          <p className={cssClasses.label}>Unit Number</p>
                          <p className={cssClasses.value}>
                            {allotment?.unitId?.wingId?.displayName} -
                            {allotment?.unitId?.unitNo}
                          </p>
                        </div>
                      </div>

                      <div className={cssClasses.unitItem}>
                        <img src={AllotmentCalenderIcon} alt="" />
                        <div>
                          <p className={cssClasses.label}>Allotment Date</p>
                          <p className={cssClasses.value}>
                            {new Date(allotment.created_at).toLocaleDateString(
                              "en-GB",
                            )}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className={cssClasses.divider} />

                    <div className={cssClasses.totalRow}>
                      <span>Total E-Mandate Amount</span>
                      <strong>
                        ₹
                        {numberWithCommas(
                          isNaN(
                            mandateAmounts[allotment.bookingId]
                              ?.totalMandateAmount,
                          )
                            ? 0 // Fallback to 0 if the value is NaN
                            : mandateAmounts[allotment.bookingId]
                                ?.totalMandateAmount || 0,
                        )}
                      </strong>
                    </div>

                    {/* CTA Button Logic */}
                    <Tooltip
                      title={
                        !allotment.bookingId
                          ? "Booking ID is missing. Cannot proceed with E-Mandate."
                          : mandateAmounts[allotment.bookingId]
                                ?.totalMandateAmount === 0
                            ? "No payment plan is available for this Booking ID. Unable to generate mandate amount."
                            : ""
                      }
                      arrow
                      slotProps={{
                        tooltip: {
                          sx: {
                            fontSize: "12px",
                            padding: "8px 12px",
                          },
                        },
                      }}
                    >
                      <span>
                        <button
                          className={`${
                            isDashboard
                              ? cssClasses.dashboardBtn
                              : cssClasses.primaryBtn
                          } ${
                            !allotment.bookingId ||
                            mandateAmounts[allotment.bookingId]
                              ?.totalMandateAmount === 0
                              ? cssClasses.disabledBtn
                              : ""
                          }`}
                          onClick={() => handleButtonClick(allotment)}
                          disabled={
                            !allotment.bookingId ||
                            mandateAmounts[allotment.bookingId]
                              ?.totalMandateAmount === 0
                          }
                        >
                          {allotment.bookingId
                            ? mandateAmounts[allotment.bookingId]
                                ?.totalMandateAmount === 0
                              ? "No E-Mandate Amount"
                              : isDashboard
                                ? "Proceed to Dashboard"
                                : "Proceed to E-Mandate"
                            : "Booking ID is missing. Cannot proceed with E-Mandate."}
                        </button>
                      </span>
                    </Tooltip>
                  </div>
                </Card>
              );
            })
          ) : (
            // Show "No Eligible E-Mandate Allotments to show!" message if no eligible allotments
            <div className={cssClasses.noDataWrapper}>
              <div className={cssClasses.noDataMsg}>
                <div className={cssClasses.emptyIcon}>
                  <img src={EmptyListIcon} alt="No Allotments" />
                </div>
                <div className={cssClasses.emptyTitle}>
                  No Eligible E-Mandate Allotments to show!
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // return (

  // <div className={cssClasses.wrapperTargetPage}>
  //   <div className={cssClasses.mainContent}>
  //     <div className={cssClasses.headerMainContent}>
  //       <div className={cssClasses.wrapperHeader}>
  //         <div className={cssClasses.wrapperTitleUserName}>
  //           <div className={cssClasses.headerTitle}>
  //             Your Eligible Allotments
  //           </div>
  //           <div>
  //             <span style={{ fontSize: "1.25rem" }}>
  //               Select an allotment to proceed with E-Mandate registration
  //             </span>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //     <div className={cssClasses.eventsWrapper}>
  //       {allotmentsPresent &&
  //         allAllotments.map((allotment) => {
  //           const isDashboard = allotment?.emandatesData?.some(
  //             (mandate) => mandate.isRegistered === true,
  //           );

  //           return (
  //             <>
  //               {allotment?.status === "Agreement Done" &&
  //                 allotment?.CRM[0]?.isEmandateEligible === true &&
  //                 (allotment?.CRM[0]?.newPaymentPlan?.Id === 163 ||
  //                   allotment?.CRM[0]?.newPaymentPlan?.Id === 165) && (
  //                   <Card
  //                     className={`${cssClasses.card} ${
  //                       isDashboard ? cssClasses.dashboardCard : ""
  //                     }`}
  //                     sx={{ boxShadow: "none !important" }}
  //                   >
  //                     <div
  //                       className={
  //                         isDashboard
  //                           ? cssClasses.dashboardInner
  //                           : cssClasses.emandateInner
  //                       }
  //                     >
  //                       {/* HEADER */}
  //                       <div className={cssClasses.cardHeaderNew}>
  //                         <div>
  //                           <h3 className={cssClasses.projectName}>
  //                             {allotment?.unitId?.projectId?.projectName}
  //                           </h3>
  //                           <p className={cssClasses.projectSub}>
  //                             {allotment?.unitId?.wingId?.displayName ||
  //                               allotment?.unitId?.wingId?.wingName}
  //                           </p>
  //                         </div>

  //                         <span className={cssClasses.bhkPill}>
  //                           {allotment?.unitId?.inventoryTypeId?.type}
  //                         </span>
  //                       </div>

  //                       {/* UNIT INFO */}
  //                       <div className={cssClasses.unitRow}>
  //                         <div className={cssClasses.unitItem}>
  //                           <img src={AllotmentCalenderIcon} alt="" />
  //                           <div>
  //                             <p className={cssClasses.label}>Unit Number</p>
  //                             <p className={cssClasses.value}>
  //                               {allotment?.unitId?.wingId?.displayName} -
  //                               {allotment?.unitId?.unitNo}
  //                             </p>
  //                           </div>
  //                         </div>

  //                         <div className={cssClasses.unitItem}>
  //                           <img src={AllotmentCalenderIcon} alt="" />
  //                           <div>
  //                             <p className={cssClasses.label}>
  //                               Allotment Date
  //                             </p>
  //                             <p className={cssClasses.value}>
  //                               {new Date(
  //                                 allotment.created_at,
  //                               ).toLocaleDateString("en-GB")}
  //                             </p>
  //                           </div>
  //                         </div>
  //                       </div>

  //                       <div className={cssClasses.divider} />

  //                       <div className={cssClasses.totalRow}>
  //                         <span>Total E-Mandate Amount</span>
  //                         <strong>
  //                           ₹
  //                           {numberWithCommas(
  //                             isNaN(
  //                               mandateAmounts[allotment.bookingId]
  //                                 ?.totalMandateAmount,
  //                             )
  //                               ? 0 // Fallback to 0 if the value is NaN
  //                               : mandateAmounts[allotment.bookingId]
  //                                   ?.totalMandateAmount || 0,
  //                           )}
  //                         </strong>
  //                       </div>
  //                       {console.log(
  //                         "mandateAmounts for allotment:",
  //                         mandateAmounts[allotment.bookingId],
  //                       )}

  //                       {/* CTA Button Logic */}

  //                       {/* <Tooltip
  //                         title={
  //                           mandateAmounts[allotment.bookingId]
  //                             ?.totalMandateAmount === 0
  //                             ? "No payment plan is available for this Booking ID. Unable to generate mandate amount."
  //                             : ""
  //                         }
  //                         arrow
  //                         slotProps={{
  //                           tooltip: {
  //                             sx: {
  //                               fontSize: "12px",
  //                               padding: "8px 12px",
  //                             },
  //                           },
  //                         }}
  //                       >
  //                         <span>
  //                           <button
  //                             className={`
  //                                 ${isDashboard ? cssClasses.dashboardBtn : cssClasses.primaryBtn}
  //                                 ${
  //                                   mandateAmounts[allotment.bookingId]
  //                                     ?.totalMandateAmount === 0
  //                                     ? cssClasses.disabledBtn
  //                                     : ""
  //                                 }
  //                               `}
  //                             onClick={() => handleButtonClick(allotment)}
  //                             disabled={
  //                               mandateAmounts[allotment.bookingId]
  //                                 ?.totalMandateAmount === 0
  //                             }
  //                           >
  //                             {mandateAmounts[allotment.bookingId]
  //                               ?.totalMandateAmount === 0
  //                               ? "No E-Mandate Amount"
  //                               : isDashboard
  //                                 ? "Proceed to Dashboard"
  //                                 : "Proceed to E-Mandate"}
  //                           </button>
  //                         </span>
  //                       </Tooltip> */}
  //                       <Tooltip
  //                         title={
  //                           !allotment.bookingId
  //                             ? "Booking ID is missing. Cannot proceed with E-Mandate."
  //                             : mandateAmounts[allotment.bookingId]
  //                                   ?.totalMandateAmount === 0
  //                               ? "No payment plan is available for this Booking ID. Unable to generate mandate amount."
  //                               : ""
  //                         }
  //                         arrow
  //                         slotProps={{
  //                           tooltip: {
  //                             sx: {
  //                               fontSize: "12px",
  //                               padding: "8px 12px",
  //                             },
  //                           },
  //                         }}
  //                       >
  //                         <span>
  //                           <button
  //                             className={`${
  //                               isDashboard
  //                                 ? cssClasses.dashboardBtn
  //                                 : cssClasses.primaryBtn
  //                             } ${
  //                               !allotment.bookingId ||
  //                               mandateAmounts[allotment.bookingId]
  //                                 ?.totalMandateAmount === 0
  //                                 ? cssClasses.disabledBtn
  //                                 : ""
  //                             }`}
  //                             onClick={() => handleButtonClick(allotment)}
  //                             disabled={
  //                               !allotment.bookingId ||
  //                               mandateAmounts[allotment.bookingId]
  //                                 ?.totalMandateAmount === 0
  //                             }
  //                           >
  //                             {allotment.bookingId
  //                               ? mandateAmounts[allotment.bookingId]
  //                                   ?.totalMandateAmount === 0
  //                                 ? "No E-Mandate Amount"
  //                                 : isDashboard
  //                                   ? "Proceed to Dashboard"
  //                                   : "Proceed to E-Mandate"
  //                               : "Booking ID is missing. Cannot proceed with E-Mandate."}
  //                           </button>
  //                         </span>
  //                       </Tooltip>

  //                       {/*
  //                       {mandateAmounts[allotment.bookingId]
  //                         ?.totalMandateAmount === 0 ? (
  //                         <div className={cssClasses.noDataMsg}>
  //                           <div className={cssClasses.emptyIcon}>
  //                             <img src={EmptyListIcon} alt="No Amount" />
  //                           </div>
  //                           <div className={cssClasses.emptyTitle}>
  //                             No E-Mandate Amount available to proceed.
  //                           </div>
  //                         </div>
  //                       ) : (
  //                         <button
  //                           className={
  //                             isDashboard
  //                               ? cssClasses.dashboardBtn
  //                               : cssClasses.primaryBtn
  //                           }
  //                           onClick={() => handleButtonClick(allotment)}
  //                           disabled={
  //                             mandateAmounts[allotment.bookingId]
  //                               ?.totalMandateAmount === 0
  //                           } // Disable the button if totalMandateAmount is 0
  //                         >
  //                           {isDashboard
  //                             ? "Proceed to Dashboard"
  //                             : "Proceed to E-Mandate"}
  //                         </button>
  //                       )} */}
  //                     </div>
  //                   </Card>
  //                 )}
  //             </>
  //           );
  //         })}

  //       {console.log("allotmentsPresent===>", allotmentsPresent)}

  //       {allotmentsPresent === false && (
  //         // <div className={cssClasses.noDataWrapper}>
  //         <div className={cssClasses.noDataMsg}>
  //           <div className={cssClasses.emptyIcon}>
  //             <img src={EmptyListIcon} alt="No Allotments" />
  //           </div>
  //           <div className={cssClasses.emptyTitle}>
  //             No E-Mandate Allotments to show!
  //           </div>
  //         </div>
  //         // </div>
  //       )}
  //     </div>

  //     {allotmentsPresent &&
  //       allAllotments?.map((allotment) => (
  //         <>
  //           {console.log("allotment for Emandate ---->", allotment)}
  //           {allotment.CRM.length > 0 ? (
  //             allotment?.CRM[0]?.isEmandateEligible === false && (
  //               <div className={cssClasses.noDataWrapper}>
  //                 <div className={cssClasses.noDataMsg}>
  //                   <div className={cssClasses.emptyIcon}>
  //                     <img src={EmptyListIcon} alt="No Allotments" />
  //                   </div>
  //                   <div className={cssClasses.emptyTitle}>
  //                     No Eligible E-Mandate Allotments to show!
  //                   </div>
  //                 </div>
  //               </div>
  //             )
  //           ) : (
  //             <div className={cssClasses.noDataWrapper}>
  //               <div className={cssClasses.noDataMsg}>
  //                 <div className={cssClasses.emptyIcon}>
  //                   <img src={EmptyListIcon} alt="No Allotments" />
  //                 </div>
  //                 <div className={cssClasses.emptyTitle}>
  //                   No Eligible E-Mandate Allotments to show!
  //                 </div>
  //               </div>
  //             </div>
  //           )}
  //         </>
  //       ))}
  //   </div>
  // </div>
  // );
};

export default EMandateAllotmentHandlerPage;
